import { API } from "aws-amplify";


  export function unsetProfile(body) {
    return new Promise((resolve, reject) => {
      API.post("insta", "/unsetprofile", {body})
        .then(res => {
            resolve(res);
          })
        .catch(err => {
          reject(err);
        });
    });
  }

  export function updatemfa(body) {
    return new Promise((resolve, reject) => {
      API.post("user", "/enableusermfa", {body})
        .then(res => {
            resolve(res);
          })
        .catch(err => {
          reject(err);
        });
    });
  }

  export function getMfaStatus() {
    return API.get("user", `/mfastatus`);
}

export function verifyPhone(body) {
  return API.post("user", `/updatecmobile`, {body})
}

export function updatePhone(body) {
  return API.put("user", `/updatephone`, {body})
}

export function globalsignout(body) {
  return API.post("user", `/globalsignout`, {body})
}

export function revoketoken(body) {
  return API.post("user", `/revoketoken`, {body})
}

export function removeUserAccount() {
  return API.del("user", "/selfDelete");
}